export default __webpack_public_path__ + "static/linkBg1-d3d959b0882c22b79abb3d466542fc43.png";